import template from "./reset-password-page.html";

const ResetPasswordPageComponent = {
  template: template,
  controller: class ResetPasswordPageController {
    /* @ngInject */
    constructor($rootScope, $state, $stateParams, $filter, User, Notification) {
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.$stateParams = $stateParams;
      this.$filter = $filter;
      this.user = User;
      this.NotificationService = Notification;
    }

    $onInit() {
      this.verificationResetPasswordToken = this.$stateParams.token;
      this.savingPassword = false;
      this.newPassword = null;
      this.repeatPassword = null;
      this.error = this.verificationResetPasswordToken
        ? null
        : (this.error = this.$filter("trans")("resetPassword.noValidToken"));
      this.loading = false;
    }

    async changePassword() {
      if (!this.passwordForm.$valid) return;
      this.savingPassword = true;
      this.loading = true;
      try {
        await this.user.verifyResetPassword(
          this.verificationResetPasswordToken,
          this.newPassword
        );
        this.newPassword = null;
        this.repeatPassword = null;
        this.passwordForm.$setPristine();
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")(
            "notificationService.message.passwordUpdated"
          ),
        });
        this.goLoginPage();
      } catch (e) {
        if (e.data === "Reset password token is invalid or expired") {
          this.error = this.$filter("trans")("resetPassword.noValidToken");
        } else {
          throw e;
        }
      }
      this.savingPassword = false;
      this.$rootScope.$applyAsync();
    }

    goLoginPage() {
      this.$state.go("login");
    }
  },
};

export default ResetPasswordPageComponent;
